import './index.scss'
$("header").addClass("head1");
$("#nav2").addClass("active");